import {
  AccidentLetterForm,
  AccidentNotificationForm,
  ApplicationForLeaveForm,
  ApplicationForLeaveNoSalaryForm,
  ApplicationForSuspendContractForm,
  ApplicationForTerminationContractForm,
  MaternityLeaveLetterForm,
  SickLetterForm,
} from "../components";
import { AFLType } from "../models";

export const getCreateFormTemplate = (aflType: AFLType | undefined) => {
  switch (aflType) {
    case AFLType.AccidentLeaveApplication:
      return AccidentLetterForm;
    case AFLType.AccidentNotification:
      return AccidentNotificationForm;
    case AFLType.AFLNoSalary:
      return ApplicationForLeaveNoSalaryForm;
    case AFLType.AFLSuspendContract:
      return ApplicationForSuspendContractForm;
    case AFLType.ApplicationForLeave:
      return ApplicationForLeaveForm;
    case AFLType.MaternityLeaveApplication:
      return MaternityLeaveLetterForm;
    case AFLType.SickLeaveApplication:
      return SickLetterForm;
    case AFLType.TerminationContractApplication:
      return ApplicationForTerminationContractForm;
    default:
      return () => <div />;
  }
};
